import logo from '../../../../../assets/logo/logo.svg';
import { Wrapper, AppFrame, Logo } from './styles';

export const AppLogo = () => (
    <Wrapper>
        <AppFrame to="/" title="Swimpion app home page">
            <Logo src={logo} alt="Logo of Swimpion" />
        </AppFrame>
    </Wrapper>
)